import { render, staticRenderFns } from "./Synthesis_bank.vue?vue&type=template&id=1d27a9f8"
import script from "./Synthesis_bank.vue?vue&type=script&lang=js"
export * from "./Synthesis_bank.vue?vue&type=script&lang=js"
import style0 from "./Synthesis_bank.vue?vue&type=style&index=0&id=1d27a9f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports